import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { ProductImageStyles } from "@stoneage/Overrides/Components/ProductImage";
import { ProductListActionsStyles } from "@stoneage/Overrides/Widgets/ProductList/ProductListActions";
import { ProductListProductInformationStyles } from "@stoneage/Overrides/Widgets/ProductList/ProductListProductInformation";
import color from "@stoneage/XDL/Utilities/color";
import xScreen from "@stoneage/XDL/Utilities/xScreen";
import { css } from "styled-components";

export const partsNumberStyle = css`
    overflow: hidden;
    box-sizing: content-box;
    overflow: hidden;
    padding-top: 7px;
`;

interface SharedProductCardStyles {
    productInformationStyles: ProductListProductInformationStyles;
    productActionsStyles: ProductListActionsStyles;
    productImage: ProductImageStyles;
}

interface PartNumbersAuthStyles {
    partNumbersAuthenticated: InjectableCss;
    partNumbersNonAuthenticated: InjectableCss;
}

export const partNumbersAuthStyles: PartNumbersAuthStyles = {
    partNumbersAuthenticated: {
        css: css`
            ${partsNumberStyle}
            padding-bottom: 7px;
            margin-bottom: 7px;
            border-top: 1px solid ${color("common.ui6")};
            border-bottom: 1px solid ${color("common.ui6")};
            margin-top: auto;
        `,
    },
    partNumbersNonAuthenticated: {
        css: css`
            ${partsNumberStyle}
            border-top: 1px solid ${color("common.ui6")};
            margin-top: auto;
            height: fit-content;
        `,
    },
};

export const verticalProductCardSharedStyles: SharedProductCardStyles & PartNumbersAuthStyles = {
    productInformationStyles: {
        productAttributes: {
            allAttributesWrapper: {
                css: css`
                    display: flex;
                    flex-direction: column;
                    gap: 4px;
                    margin-bottom: 6px;
                `,
            },
            attributeWrapper: {
                css: css`
                    gap: 4px;
                    display: flex;
                    line-height: 0.9;
                `,
            },
        },
        productPartNumbers: {
            container: {
                css: css`
                    display: flex;
                    flex-direction: column;
                    .item-cont {
                        line-height: 18px;
                        padding: 0 0 0 2px;
                    }
                `,
            },
        },
        attributesWrapper: {
            css: css`
                overflow: hidden;
            `,
        },
        partNumbersWrapper: {
            css: css`
                ${partsNumberStyle}
                padding-bottom: 7px;
                margin-bottom: 7px;
                border-bottom: 1px solid ${color("common.ui6")};
            `,
        },
    },
    productActionsStyles: {
        availabilityPriceWrapper: {
            css: css`
                display: flex;
                justify-content: space-between;
                align-items: flex-end;
                && .variant-product {
                    width: 100%;
                }
            `,
        },
    },
    productImage: {
        linkWrappingImage: {
            css: css`
                height: 308px;
            `,
        },
        image: {
            css: css`
                height: 308px;
                width: 100%;
            `,
        },
    },
    ...partNumbersAuthStyles,
};

export const horizontalProductCardSharedStyles: SharedProductCardStyles = {
    productInformationStyles: {
        descriptionWrapper: {
            css: css`
                overflow: hidden;
                line-height: 19px;
                margin-bottom: 12px;
            `,
        },
        productAttributes: {
            allAttributesWrapper: {
                css: css`
                    display: flex;
                    overflow: hidden;
                    margin-bottom: 6px;
                    line-height: 18px;
                    @media (max-width: 1024px) {
                        flex-direction: column;
                    }
                `,
            },
            attributeWrapper: {
                css: css`
                    display: flex;
                    flex-direction: column;
                    width: calc(100% / 3);
                    margin-right: 12px;
                    white-space: nowrap;
                `,
            },
        },
        productPartNumbers: {
            container: {
                css: css`
                    display: flex;
                    @media (max-width: 1024px) {
                        flex-direction: column;
                    }
                    .item-cont {
                        line-height: 18px;
                        padding: 0;
                        width: calc(100% / 3);
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        @media (max-width: 1024px) {
                            width: 100%;
                        }
                    }
                `,
            },
        },
        partNumbersWrapper: {
            css: css`
                ${partsNumberStyle}
                margin-top: auto;
                border-top: 1px solid ${color("common.ui6")};
                @media (max-width: 768px) {
                    height: fit-content;
                    margin-bottom: 0;
                }
            `,
        },
        attributesWrapper: {
            css: css`
                box-sizing: content-box;
                padding-bottom: 11px;
                overflow: hidden;
                @media (max-width: 1024px) {
                    padding-bottom: 7px;
                }
            `,
        },
    },
    productActionsStyles: {
        availabilityPriceWrapper: {
            css: css`
                display: flex;
                flex-direction: column;
                gap: 1px;
                @media (max-width: 1024px) {
                    flex-direction: row;
                    justify-content: space-between;
                    align-items: flex-end;
                }
                && .variant-product {
                    flex-direction: column;
                    align-items: flex-start;
                }
            `,
        },
    },
    productImage: {
        linkWrappingImage: {
            css: css`
                height: 112px;
            `,
        },
        image: {
            css: css`
                height: 112px;
            `,
        },
    },
};
